import { z } from "zod";
import {
  BILLING_AMOUNT,
  BILLING_CATEGORY,
  BILLING_DATE,
  BILLING_MONTH_YEAR,
  COMMENT,
  CURR_OWNER_ID,
  CURR_OWNER_LAST_NAME,
  DOCUMENT_TYPE,
  DRCR,
  DUE_DATE,
  GL_ACCOUNT,
  LINE_BILLING_AMOUNT,
  LINE_ITEMS,
  PAYMENT_TERM,
  POSTING_DATE,
  PROPERTY_BLOCK,
  PROPERTY_ID,
  PROPERTY_MODEL,
  STREET_ADDRESS,
  TRANSACTION_TYPE,
  UNIT_NO,
} from "./consts";

export const schema = z.object({
  [DOCUMENT_TYPE]: z.string().min(1, "This field is required"),
  [BILLING_MONTH_YEAR]: z.string().min(1, "This field is required"),
  [BILLING_DATE]: z.string().min(1, "This field is required"),
  [BILLING_AMOUNT]: z.string().min(1, "This field is required"),
  [DUE_DATE]: z.string().min(1, "This field is required"),
  [TRANSACTION_TYPE]: z.string().min(1, "This field is required"),
  [GL_ACCOUNT]: z.string().min(1, "This field is required"),
  [PAYMENT_TERM]: z.string().min(1, "This field is required"),
  [COMMENT]: z.string().min(1, "This field is required"),
  [POSTING_DATE]: z.string().min(1, "This field is required"),
  // [POSTING_MONTH]: z.string().min(1, "This field is required"),
  // [YEAR]: z.string().min(1, "This field is required"),
  [LINE_ITEMS]: z
    .object({
      [BILLING_CATEGORY]: z.string().optional(),
      [PROPERTY_MODEL]: z.string().optional(),
      [PROPERTY_BLOCK]: z.string().optional(),
      [PROPERTY_ID]: z.string().optional(),
      [UNIT_NO]: z.string().optional(),
      [STREET_ADDRESS]: z.string().optional(),
      [CURR_OWNER_ID]: z.string().optional(),
      [CURR_OWNER_LAST_NAME]: z.string().optional(),
      [DRCR]: z.string().optional(),
      [LINE_BILLING_AMOUNT]: z.string().optional(),
    })
    .array(),
});

export type formValues = z.infer<typeof schema>;
